import axios from "axios";

const axiosInstance = axios.create({
  // Base URL Or QE Furniture Gold
  baseURL: "https://qewbackend.softwisesol.com",
  withCredentials: true,
});
export default axiosInstance;
